"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexWithOpacity = void 0;
const hexWithOpacity = (hex, opacity) => `${hex}${Math.floor(opacity * 255).toString(16)}`;
exports.hexWithOpacity = hexWithOpacity;
